/**
 * JotRx Guide Link
 *
 * The "How JotRx works" secondary action under a JotRx setup call to action
 * (GDN-3700). Targets the prescribing guide hub; GuideLink renders nothing
 * while feature_guide_links is closed or the hub is unpublished, so the
 * surrounding layout never reserves space for it.
 */

import { GuideLink, type GuideSurfaceId } from '@features/knowledge-base/links';

export function JotRxGuideLink({ surfaceId }: { surfaceId: GuideSurfaceId }) {
  return (
    <GuideLink
      surfaceId={surfaceId}
      shape="secondary-action"
      topic="prescribing"
      featureName="JotRx"
    />
  );
}
